.wrap {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-top: 1.5px solid var(--color-ink);
}

.section {
  border-bottom: 1.5px solid var(--color-ink);
}

.header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 0;
  background: transparent;
  border: 0;
  font: inherit;
  cursor: pointer;
  color: var(--color-ink);
  text-align: left;
}

.header:disabled { cursor: default; opacity: 0.5; }

.title {
  font-family: var(--font-display);
  font-size: 1.4rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.toggle {
  font-size: 1.6rem;
  font-weight: 300;
  line-height: 1;
  color: var(--color-ink);
  width: 28px;
  text-align: center;
  flex: 0 0 auto;
}

.body {
  padding: 4px 4px 24px;
  color: var(--color-ink);
}

.bullets {
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 0.95rem;
  line-height: 1.55;
}

.links {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.fileLink {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 0.95rem;
  color: var(--color-ink);
  text-decoration: none;
}

.fileLink:hover { color: var(--color-ember-dark); }

.fileIcon {
  color: var(--color-ember);
  display: inline-flex;
}

.partsTable {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.partsTable th {
  text-align: left;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--color-ink-soft);
  font-weight: 700;
  padding: 8px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.partsTable td {
  padding: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.mono {
  font-family: ui-monospace, "SF Mono", "Menlo", monospace;
  font-size: 0.85rem;
}

.text {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.55;
}

@media (max-width: 768px) {
  .title { font-size: 1.05rem; letter-spacing: 0.08em; }
  .header { padding: 16px 0; }
  .toggle { font-size: 1.4rem; }
}
